import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { CompanySvg } from '../assets/Company.svg';
import { EmployeesSvg } from '../assets/Employees.svg';
import { QualificationsSvg } from '../assets/Qualifications.svg';
import { WorkerSvg } from '../assets/Worker.svg';

export const COMPANY_INFOMATION_LIST = [
  {
    id: 1,
    keyName: 'establishment',
    iconElement: (<CompanySvg />),
    text: '設立年数',
  },
  {
    id: 2,
    keyName: 'employees',
    iconElement: (<EmployeesSvg />),
    text: '従業員数',
  },
  {
    id: 3,
    keyName: 'qualifications',
    iconElement: (<QualificationsSvg />),
    text: '保有資格',
  },
  {
    id: 4,
    keyName: 'inHouse',
    iconElement: (<WorkerSvg />),
    text: '完全自社施工',
  },
];
